import { Link, LinkProps } from "react-router-dom";
import { GetForwardRefExoticComponentProps } from "types";
import { createButton } from "./ButtonBase";

export type LinkButtonProps = GetForwardRefExoticComponentProps<typeof LinkButton>;
export const LinkButton = createButton<HTMLAnchorElement, LinkProps>(Link);
